import { useTranslation } from 'react-i18next';
import { Icon } from './Icon';

/** Shared charge stepper: edits the selected atom live, or prepares a charge to apply. */
export function ChargeControl({
  value,
  onChange,
  live = false
}: {
  readonly value: number;
  readonly live?: boolean;
  readonly onChange: (value: number) => void;
}) {
  const { t } = useTranslation();
  return (
    <div className="charge-control" role="group" aria-label={t('workspace.rail.charge.group')}>
      <span className="charge-control-label">{t('workspace.rail.charge.label')}</span>
      <output
        aria-label={t(live ? 'workspace.rail.charge.selectedValue' : 'workspace.rail.charge.value')}
        aria-live="polite"
      >
        {value > 0 ? `+${value}` : String(value).replace('-', '−')}
      </output>
      <button
        type="button"
        className="icon-button"
        aria-label={t('workspace.rail.charge.increase')}
        title={t(live ? 'workspace.rail.charge.increaseLiveHint' : 'workspace.rail.charge.increaseHint')}
        onClick={() => onChange(value + 1)}
      >
        <Icon name="add" />
      </button>
      <button
        type="button"
        className="icon-button"
        aria-label={t('workspace.rail.charge.decrease')}
        title={t(live ? 'workspace.rail.charge.decreaseLiveHint' : 'workspace.rail.charge.decreaseHint')}
        onClick={() => onChange(value - 1)}
      >
        <Icon name="remove" />
      </button>
    </div>
  );
}
